'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
function TakeNextChatButton(props) {
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    marginBlockStart: "300",
    marginBlockEnd: "500",
    children: /*#__PURE__*/_jsx(FormControl, {
      error: props.failed,
      validationMessage: props.failed ? /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "all-chats-taken-message",
        message: "app.card.queue.alert.message"
      }) : null,
      children: /*#__PURE__*/_jsx(LoadingButton, {
        "data-test-id": "take-next-chat-button-internal",
        disabled: props.disabled,
        onClick: props.onClick,
        size: "small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "take-next-chat-button-label",
          message: "app.card.queue.button.label"
        })
      })
    })
  });
}
TakeNextChatButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  failed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
export default TakeNextChatButton;